import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { MessageConstants } from '../../../app/shared/constants/message-constants';
import { ITrainingItemGroupDetailsView } from '../models/training-item-group-details-view';

@Injectable({
  providedIn: 'root'
})
export class TrainingItemPersistenceService {

  closeAndResetTrainingItemSlider$ = new Subject<boolean>();
  trainingItemSaveInProgress$ = new Subject<boolean>();
  isEditTrainingItemGroupSlider: boolean = false;
  isTrainingItemGroupUpdated: boolean = true;
  private selectedTrainingItemGroupForEdit: ITrainingItemGroupDetailsView | null = null;


  constructor(private confirmationService: ConfirmationService) { }

  openConfirmationDialog = () => {
    this.confirmationService.confirm({
      message: MessageConstants.Slider_Confirmation_Text,
      header: MessageConstants.Slider_Confirmation_Header,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeAndResetTrainingItemSlider$.next(true);
        this.isTrainingItemGroupUpdated = false;
      },
    });
  }

  updateSelectedTrainingItemGroup = (trainingItemGroup: ITrainingItemGroupDetailsView | null) => {
    this.selectedTrainingItemGroupForEdit = trainingItemGroup;
  }

  getSelectedTrainingItemGroupForEdit = (): ITrainingItemGroupDetailsView | null => {
    return this.selectedTrainingItemGroupForEdit;
  }

  updateEditTrainingItemGroupSlider = (isEdit: boolean) => {
    this.isEditTrainingItemGroupSlider = isEdit;
    this.isTrainingItemGroupUpdated = isEdit;
  }


}
